module.exports = __webpack_public_path__ + "img/logo-mazzitech-light.21be33d1.svg";